import { UAParser } from 'ua-parser-js'

const { os } = new UAParser().getResult()

export const OS = os.name ?? ''

export const isMac = OS === 'Mac OS'

export const isWindows = OS.includes('Windows')
